module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    ref: "profileForm",
    staticClass: "profile-form",
    attrs: {
      "model": _vm.profileForm,
      "label-width": "190px",
      "label-position": "left"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [(_vm.isProfileComplete) ? _c('div', [_c('empty', [_vm._v("Profile Complete: All important sections of this profile are successfully completed!")])], 1) : _c('div', [_c('p', {
    staticClass: "info-text"
  }, [_vm._v("Add more information to this profile")])]), _vm._v(" "), (_vm.showContactInfo) ? _c('div', [_c('h3', [_c('el-icon', {
    attrs: {
      "name": "phone"
    }
  }), _vm._v(" Contact Information\n      ")], 1), _vm._v(" "), (!_vm.isFieldPresent('email_address')) ? _c('el-form-item', {
    attrs: {
      "label": "Email",
      "error": _vm.emailError
    }
  }, [_c('el-input', {
    on: {
      "blur": _vm.validateEmail,
      "input": function($event) {
        return _vm.sanitizeInput('email_address')
      }
    },
    model: {
      value: (_vm.profileForm.email_address),
      callback: function($$v) {
        _vm.$set(_vm.profileForm, "email_address", $$v)
      },
      expression: "profileForm.email_address"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isFieldPresent('mobile_number')) ? _c('el-form-item', {
    attrs: {
      "label": "Mobile Number"
    }
  }, [_c('el-input', {
    on: {
      "input": function($event) {
        _vm.profileForm.mobile_number = _vm.profileForm.mobile_number.replace(/[^0-9]/g, '');
      },
      "blur": function($event) {
        return _vm.handleInput('mobile_number')
      }
    },
    model: {
      value: (_vm.profileForm.mobile_number),
      callback: function($$v) {
        _vm.$set(_vm.profileForm, "mobile_number", $$v)
      },
      expression: "profileForm.mobile_number"
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.showPersonalInfo) ? _c('div', [_c('h3', [_c('el-icon', {
    attrs: {
      "name": "user"
    }
  }), _vm._v(" Personal Information\n      ")], 1), _vm._v(" "), (!_vm.isFieldPresent('name')) ? _c('el-form-item', {
    attrs: {
      "label": "Name"
    }
  }, [_c('el-input', {
    on: {
      "blur": function($event) {
        return _vm.handleInput('name')
      },
      "input": function($event) {
        return _vm.sanitizeInput('name')
      }
    },
    model: {
      value: (_vm.profileForm.name),
      callback: function($$v) {
        _vm.$set(_vm.profileForm, "name", $$v)
      },
      expression: "profileForm.name"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isFieldPresent('gender')) ? _c('el-form-item', {
    attrs: {
      "label": "Gender"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select Gender"
    },
    model: {
      value: (_vm.profileForm.gender),
      callback: function($$v) {
        _vm.$set(_vm.profileForm, "gender", $$v)
      },
      expression: "profileForm.gender"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Male",
      "value": "Male"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Female",
      "value": "Female"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Other",
      "value": "Other"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.isFieldPresent('age_range')) ? _c('el-form-item', {
    attrs: {
      "label": "Age"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select Age"
    },
    model: {
      value: (_vm.profileForm.age_range),
      callback: function($$v) {
        _vm.$set(_vm.profileForm, "age_range", $$v)
      },
      expression: "profileForm.age_range"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Under 18",
      "value": "Under 18"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "18-24",
      "value": "18-24"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "25-34",
      "value": "25-34"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "35-49",
      "value": "35-49"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "50-64",
      "value": "50-64"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "65+",
      "value": "65+"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.isFieldPresent('id_number')) ? _c('el-form-item', {
    attrs: {
      "label": "ID Number"
    }
  }, [_c('el-input', {
    on: {
      "input": function($event) {
        return _vm.sanitizeInput('id_number')
      },
      "blur": function($event) {
        return _vm.handleInput('id_number')
      }
    },
    model: {
      value: (_vm.profileForm.id_number),
      callback: function($$v) {
        _vm.$set(_vm.profileForm, "id_number", $$v)
      },
      expression: "profileForm.id_number"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isFieldPresent('location')) ? _c('el-form-item', {
    attrs: {
      "label": "Location"
    }
  }, [_c('el-input', {
    on: {
      "blur": function($event) {
        return _vm.handleInput('location')
      },
      "input": function($event) {
        return _vm.sanitizeInput('location')
      }
    },
    model: {
      value: (_vm.profileForm.location),
      callback: function($$v) {
        _vm.$set(_vm.profileForm, "location", $$v)
      },
      expression: "profileForm.location"
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.showSocialInfo) ? _c('div', [_c('h3', [_c('el-icon', {
    attrs: {
      "name": "link"
    }
  }), _vm._v(" Social Media\n      ")], 1), _vm._v(" "), (!_vm.isFieldPresent('twitter_handle')) ? _c('el-form-item', {
    attrs: {
      "label": "Twitter"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "@twitter_handle"
    },
    on: {
      "blur": function($event) {
        return _vm.handleAtSymbol('twitter_handle')
      },
      "input": function($event) {
        return _vm.sanitizeInput('twitter_handle')
      }
    },
    model: {
      value: (_vm.profileForm.twitter_handle),
      callback: function($$v) {
        _vm.$set(_vm.profileForm, "twitter_handle", $$v)
      },
      expression: "profileForm.twitter_handle"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isFieldPresent('instagram_handle')) ? _c('el-form-item', {
    attrs: {
      "label": "Instagram"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "@instagram_handle"
    },
    on: {
      "blur": function($event) {
        return _vm.handleAtSymbol('instagram_handle')
      },
      "input": function($event) {
        return _vm.sanitizeInput('instagram_handle')
      }
    },
    model: {
      value: (_vm.profileForm.instagram_handle),
      callback: function($$v) {
        _vm.$set(_vm.profileForm, "instagram_handle", $$v)
      },
      expression: "profileForm.instagram_handle"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isFieldPresent('facebook_profile')) ? _c('el-form-item', {
    attrs: {
      "label": "Facebook"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Facebook username"
    },
    on: {
      "blur": function($event) {
        return _vm.handleInput('facebook_profile')
      },
      "input": function($event) {
        return _vm.sanitizeInput('facebook_profile')
      }
    },
    model: {
      value: (_vm.profileForm.facebook_profile),
      callback: function($$v) {
        _vm.$set(_vm.profileForm, "facebook_profile", $$v)
      },
      expression: "profileForm.facebook_profile"
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', [_c('h3', [_c('i', {
    staticClass: "fa fa-exchange",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Channels Optins and Permission\n      ")]), _vm._v(" "), _vm._l((_vm.initialOptins), function(option, index) {
    return _c('el-form-item', {
      key: index,
      staticClass: "optin-permission",
      attrs: {
        "label": option.channel
      }
    }, [(!_vm.isOriginatorValid) ? _c('el-tooltip', {
      attrs: {
        "placement": "top",
        "content": "Mobile number is required for opt-in."
      }
    }, [_c('el-switch', {
      attrs: {
        "disabled": !_vm.isOriginatorValid
      },
      on: {
        "change": function (value) { return _vm.handleUpdateOptin(value, option); }
      },
      model: {
        value: (option.opt_in),
        callback: function($$v) {
          _vm.$set(option, "opt_in", $$v)
        },
        expression: "option.opt_in"
      }
    })], 1) : _c('el-switch', {
      attrs: {
        "disabled": !_vm.isOriginatorValid
      },
      on: {
        "change": function (value) { return _vm.handleUpdateOptin(value, option); }
      },
      model: {
        value: (option.opt_in),
        callback: function($$v) {
          _vm.$set(option, "opt_in", $$v)
        },
        expression: "option.opt_in"
      }
    })], 1)
  })], 2)]), _vm._v(" "), _c('span', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [(!_vm.isProfileComplete) ? _c('el-button', {
    staticClass: "ibox-tool-btn",
    attrs: {
      "type": "danger",
      "size": "small",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("Cancel")]) : _vm._e(), _vm._v(" "), (!_vm.isProfileComplete) ? _c('el-button', {
    staticClass: "ibox-tool-btn",
    attrs: {
      "type": "primary",
      "size": "small",
      "loading": _vm.savingProfile,
      "disabled": _vm.isFormEmpty && !_vm.detectChanges(),
      "plain": ""
    },
    on: {
      "click": _vm.handleFormSave
    }
  }, [_vm._v("Save")]) : _vm._e(), _vm._v(" "), (_vm.isProfileComplete) ? _c('el-button', {
    staticClass: "ibox-tool-btn",
    attrs: {
      "type": "primary",
      "size": "small",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("Got It")]) : _vm._e()], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3665b4b3","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/permission/profile/forms/EnhanceProfileForm.vue
// module id = 3217
// module chunks = 3